// extracted by mini-css-extract-plugin
export var callCard = "_lm-0";
export var callMessageButton = "_lm-1";
export var helpIcon = "_lm-3";
export var helpIconContainer = "_lm-4";
export var verticalDivider = "_lm-2";